import { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';

import PageWithSidebar from 'components/PageWithSidebar';
import PackageSidebar from 'components/PackageSidebar';
import PackageEditTabs from 'components/PackageEditTabs';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';

import { withData } from 'lib';
import { PackageEditPageQuery } from '__generated__/PackageEditPageQuery.graphql';
import NotFound from 'components/NotFound';

const query = graphql`
  query PackageEditPageQuery($id: ID!, $first: Int!) {
    package(id: $id) {
      name

      ...PackageEditTabs_package
      ...PackageSidebar_package
    }

    ...PackageEditTabs_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<PackageEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [{ link: '/packages', name: 'Pasiūlymai' }];

const PackageEditPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<PackageEditPageQuery>(query, preloadedQuery);

  if (!data.package) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<PackageSidebar package={data.package} />}
      breadcrumbs={[...breadcrumbs, { name: data.package.name }]}>
      <PackageEditTabs package={data.package} data={data} />
    </PageWithSidebar>
  );
};

export default withData<PackageEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton tabs={7} breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams, currentUser }) => ({
    id: routeParams.id,
    first: currentUser.itemsPerPage,
  }),
})(PackageEditPage);
